import { render, staticRenderFns } from "./CopyrightRegistry.vue?vue&type=template&id=3bada574&scoped=true&"
import script from "./CopyrightRegistry.vue?vue&type=script&lang=js&"
export * from "./CopyrightRegistry.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightRegistry.vue?vue&type=style&index=0&id=3bada574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bada574",
  null
  
)

export default component.exports